(function () {
  'use strict';

  function initVrc(section) {
    var openButtons = section.querySelectorAll('[data-vrc-open]');
    var modals = section.querySelectorAll('[data-vrc-modal]');
    var activeModal = null;

    function getVideoEl(modal) {
      return modal.querySelector('video');
    }

    function openModal(modal) {
      if (!modal) return;
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('vrc-lock');
      activeModal = modal;

      var closeBtn = modal.querySelector('.vrc__modal-close');
      if (closeBtn) closeBtn.focus();

      var video = getVideoEl(modal);
      if (video) {
        video.currentTime = 0;
        var playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(function () {
            /* autoplay blocked, user can press play in native controls */
          });
        }
      }
    }

    function closeModal(modal) {
      if (!modal) return;
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('vrc-lock');

      var video = getVideoEl(modal);
      if (video) {
        video.pause();
        video.currentTime = 0;
      }
      activeModal = null;
    }

    openButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var targetId = btn.getAttribute('data-modal-target');
        var modal = section.querySelector('#' + targetId);
        openModal(modal);
      });
    });

    modals.forEach(function (modal) {
      modal.querySelectorAll('[data-vrc-close]').forEach(function (closeEl) {
        closeEl.addEventListener('click', function () {
          closeModal(modal);
        });
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && activeModal) {
        closeModal(activeModal);
      }
    });
  }

  function initAll() {
    document.querySelectorAll('.vrc').forEach(initVrc);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.vrc');
    if (section) initVrc(section);
  });
})();
